var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"body-style":{padding: '24px 32px'},"bordered":false}},[_c('icon-selector',{on:{"change":_vm.handleIconChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }